function closeModal(modal) {
  if (!modal) {
    return;
  }

  modal.style.display = "none";

  const form = modal.querySelector("form");
  if (form) {
    form.reset();
  }

  // Hide success message
  const successMessage = modal.querySelector(".form-status");
  if (successMessage) {
    successMessage.style.display = "none";
  }
}

document.querySelectorAll(".open-modal").forEach((item) => {
  item.addEventListener("click", (event) => {
    const modalId = event.currentTarget.getAttribute("data-modal-id");
    const modal = document.getElementById(modalId);
    if (!modal) {
      return;
    }

    modal.style.display = "block"; // Open the modal

    // Close the modal if the user clicks outside of it
    window.addEventListener("click", function (e) {
      if (e.target == modal) {
        closeModal(modal);
      }
    });
  });
});

document.querySelectorAll(".close").forEach((closeButton) => {
  closeButton.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    const modal = closeButton.closest(".modal");
    if (modal) {
      closeModal(modal);
    }
  });
});
